import React from 'react';
import ToggleContainer from 'components/Layout/ToggleContainer';
import InstantPass from 'components/ReusableForms/InstantPass';

const InstantPassForm = ({ eventId, fetchEventDetails }) => {
  return (
    <ToggleContainer
      title="Instant Pass"
      isError={eventId === 'add-event'}
      errorMessage="Event is required."
    >
      <div className="row cmb-20">
        <div className="col-md-8">
          <InstantPass
            eventId={eventId}
            fetchEventDetails={fetchEventDetails}
          />
        </div>
      </div>
    </ToggleContainer>
  );
};

export default InstantPassForm;
